// src/components/About.js
import React from 'react';
import { Container, Row, Col, /* Image */ } from 'react-bootstrap';
// import aboutImage from '../assets/images/about.png'; // Ensure you have an about image

const About = () => {
  return (
    <Container className="my-5">
      <h2 className="text-center mb-4" data-aos="fade-up">About RxRooster</h2>
      <Row>
        {/* <Col md={6} data-aos="fade-right">
          <Image src={aboutImage} fluid rounded />
        </Col> */}
        <Col md={12} data-aos="fade-left">
          <p>
            RxRooster is reimagining how CRNA staffing works. We connect exceptional Certified Registered Nurse Anesthetists with hospitals and healthcare teams nationwide — quickly, transparently, and without the traditional middlemen.

We know the value CRNAs bring to patient care. That’s why our approach is built around alignment, not just availability. Whether you're filling one shift or building your anesthesia team, RxRooster delivers personalized matches that fit your clinical, cultural, and operational needs — without markups, non-competes, or long delays.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
